import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { CacheService } from './cache.service';

@Injectable({
    providedIn: "root"
})
export class TypeStatusReportService {

    className = 'TypeStatusReportService';

    constructor(private http: HttpClient, @Inject("environment") private environment: any, private cacheService: CacheService) { }

    getAll(cache = true, cacheKey = "allStatusReport"): any {
        if (this.cacheService.canUseCache(cacheKey) && cache) {
            return this.cacheService.getCacheData(cacheKey);
          } else {
            let observable = this.http.get(this.environment.base_URL + "/types-status-report").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
            }))
            this.cacheService.updateCacheReq(cacheKey);
            return observable;
          }
    }

}